import { ColorTokenKey } from '@faire/web-api--source/indigofair/data/ColorTokenKey';
import { IAction } from '@faire/web-api--source/indigofair/data/IAction';
import { IElementLoggingData } from '@faire/web-api--source/indigofair/data/IElementLoggingData';
import { ISlateText } from '@faire/web-api--source/indigofair/data/ISlateText';
import { TextAccessibilityAttribute } from '@faire/web-api--source/indigofair/data/TextAccessibilityAttribute';
import { TextDecorator } from '@faire/web-api--source/indigofair/data/TextDecorator';
import { TextJustification } from '@faire/web-api--source/indigofair/data/TextJustification';
import { TextStyleType } from '@faire/web-api--source/indigofair/data/TextStyleType';

export namespace ISDUIText {
  export namespace ISDUITextSegment {
    /**
     * Return an instance of ISDUITextSegment with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<ISDUITextSegment>
    ): ISDUITextSegment =>
      ({
        text_on_click: [],
        decorators: [],
        ...(partial ?? {}),
      }) as ISDUITextSegment;
  }

  export interface ISDUITextSegment {
    /**
     * @deprecated
     */
    slate_text: ISlateText | undefined;
    text_on_click: Array<IAction>;
    content: string | undefined;
    type: keyof typeof TextStyleType | undefined;
    decorators: Array<keyof typeof TextDecorator>;
    color: keyof typeof ColorTokenKey | undefined;
  }

  /**
   * Return an instance of ISDUIText with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ISDUIText>): ISDUIText =>
    ({
      slate_text_segments: [],
      ...(partial ?? {}),
    }) as ISDUIText;
}

/**
 * =========================================
 * Text Element
 * =========================================
 */
export interface ISDUIText {
  slate_text_segments: Array<ISDUIText.ISDUITextSegment>;
  logging_data: IElementLoggingData | undefined;
  max_lines: number | undefined;
  text_justification: keyof typeof TextJustification | undefined;
  /**
   * Used for accessibility purposes, optional override to determine headings programmatically.
   */
  text_accessibility_attribute:
    | keyof typeof TextAccessibilityAttribute
    | undefined;
}
